import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const TIME_ZONE = "America/Denver";

export const OFFICE_PHONE = "970-749-0028";

export const SAME_DAY_WEEKEND_MESSAGE =
  "If you are scheduling same-day or weekend service, please call or text our office to confirm availability.";

export function isSameDayOrWeekend(date: Date | string | null | undefined): boolean {
  if (!date) {
    return false;
  }

  let target;
  let now;
  try {
    target = dayjs(date).tz(TIME_ZONE);
    now = dayjs().tz(TIME_ZONE);
  } catch {
    target = dayjs(date);
    now = dayjs();
  }

  if (!target.isValid()) {
    return false;
  }

  const day = target.day(); // 0 Sun ... 6 Sat
  const isWeekend = day === 0 || day === 6;
  const isSameDay =
    target.year() === now.year() &&
    target.month() === now.month() &&
    target.date() === now.date();

  return isWeekend || isSameDay;
}
